import { Component, Input, OnInit } from '@angular/core';
import { MeetingSchedulingData } from '../../../../shared/models/meetings.model';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { faChevronRight, faCalendarDay, faArrowLeft } from '@fortawesome/pro-duotone-svg-icons';

@Component({
  selector: 'app-meetings-new',
  templateUrl: './meetings-new.component.html',
  styleUrl: './meetings-new.component.scss',
  standalone: false
})
export class MeetingsNewComponent {

  @Input() schedulingData!: MeetingSchedulingData;
  protected selectedAgenda: SafeResourceUrl | null = null;

  public states = {
    selectedTab: 'default'
  };

  constructor(private _sanitizer: DomSanitizer) {}

  public icons = {
    chevronRight: faChevronRight,
    calendarDay: faCalendarDay,
    arrowLeft: faArrowLeft,
  };


  public selectAgenda(agenda: string): void {
    this.selectedAgenda =  this._sanitizer.bypassSecurityTrustResourceUrl(agenda); 
  }

  public removeSelectedAgenda(): void {
    this.selectedAgenda = null;
  }
}
